import { render, staticRenderFns } from "./inputInvoice.vue?vue&type=template&id=723f22d0&scoped=true"
import script from "./inputInvoice.vue?vue&type=script&lang=js"
export * from "./inputInvoice.vue?vue&type=script&lang=js"
import style0 from "./inputInvoice.vue?vue&type=style&index=0&id=723f22d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "723f22d0",
  null
  
)

export default component.exports